import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="border-t border-white/8 py-14">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:px-8 md:flex-row md:items-center">
        <div className="flex items-center gap-4">
          <img src="/logo.png" alt="PreNet" className="h-11 w-auto" data-testid="footer-logo-image" />
          <div>
            <p className="font-display text-sm font-bold tracking-[0.18em] text-ink">PRENET</p>
            <p className="mt-1 text-xs text-ink-muted">{t.footer.tagline}</p>
          </div>
        </div>
        <p className="max-w-sm font-mono text-[10px] uppercase leading-relaxed tracking-[0.15em] text-ink-subtle">
          {t.footer.disclaimer}
        </p>
        <div className="flex items-center gap-6">
          <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-ink-subtle">
            {t.footer.rights}
          </span>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-mono text-[10px] uppercase tracking-[0.15em] text-ink-subtle transition-colors hover:text-signal"
          >
            {t.footer.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
